import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth on mount
    const storedToken = localStorage.getItem("golfmarked_token");
    const storedUser = localStorage.getItem("golfmarked_user");
    
    if (storedToken && storedUser) {
      try {
        setToken(storedToken);
        setUser(JSON.parse(storedUser));
      } catch (e) {
        // Invalid stored data, clear it
        localStorage.removeItem("golfmarked_token");
        localStorage.removeItem("golfmarked_user");
      }
    }
    setLoading(false);
  }, []);

  // Regular email/password login
  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem("golfmarked_token", authToken);
    localStorage.setItem("golfmarked_user", JSON.stringify(userData));
  };

  // Google login - same as regular but can include picture
  const loginWithGoogle = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem("golfmarked_token", authToken);
    localStorage.setItem("golfmarked_user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("golfmarked_token");
    localStorage.removeItem("golfmarked_user");
  };

  const isAuthenticated = () => {
    return !!token && !!user;
  };

  const getAuthHeaders = () => {
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login,
        loginWithGoogle,
        logout,
        isAuthenticated,
        getAuthHeaders,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthContext;
